import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getSortAttribute } from '../../cows/reducer';
import { setCowSort } from '../../cows/actions';
import { setSidebarVisibility } from '../../cowFilters/actions';
import { getCowTypeText, sortOptions, countFilterMatch } from '../reducer';
import './search-header.scss';
import MagnifyIcon from '../../util/icons/components/MagnifyIcon';
import analytics from '../../util/analytics';

const mapStateToProps = state => ({
  cowCount: countFilterMatch(state),
  cowType: getCowTypeText(state),
  sort: getSortAttribute(state)
});

const mapDispatchToProps = dispatch => ({
  setSort: (sort) => dispatch(setCowSort(sort)),
  showSidebar: () => dispatch(setSidebarVisibility(true))
});

class SearchHeader extends Component {
  constructor (props) {
    super(props);
    this.state = {
      open: false
    };
    this.wrapperRef = React.createRef();
    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setSort = this.setSort.bind(this);
    this.showSidebar = this.showSidebar.bind(this);
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside (event) {
    if (this.wrapperRef && this.state.open === true &&
        !this.wrapperRef.current.contains(event.target)) {
      this.setState({ open: false });
    }
  }

  toggleVisibility () {
    this.setState({ open: !this.state.open });
  }

  setSort (option) {
    analytics('send', 'event', 'searchHeader', 'sort', 'option');
    this.props.setSort(option);
  }

  showSidebar () {
    analytics('send', 'event', 'searchHeader', 'showSidebar');
    this.props.showSidebar();
  }

  renderDropDownOptions () {
    return sortOptions.map(option => (
      <li key={ option }
        data-cy={ `desktop-select-option-${option}` }
        onClick={() => this.setSort(option)}>
        { option }
      </li>
    ));
  }

  render () {
    const optionsClass = this.state.open
      ? 'dropdown-options' : 'dropdown-options hidden';
    return (
      <div id='bb-search-header'>
        <div className="show-sidebar"
          onClick={ this.showSidebar }
          data-cy="show-sidebar-filters-button">
          <MagnifyIcon /> Refine
        </div>
        <div className='count'>
          <span className='number'>
            { this.props.cowCount.toLocaleString() }
          </span>
          { this.props.cowType }
          <span className="match-your-search">{ ' match your search' }</span>
        </div>
        <div ref={this.wrapperRef}
          className='sort'
          data-cy="sort-select-desktop"
          onClick={ this.toggleVisibility }>
          { 'Sort by' }
          <p className='attribute'>{ this.props.sort }</p>
          <ul className={ optionsClass }>
            { this.renderDropDownOptions() }
          </ul>
        </div>
        <div className="triangle-wrapper">
          <div className={(this.props.cowCount === 0) ? null : 'triangle'}>
          </div>
        </div>
      </div>
    );
  }
}

SearchHeader.propTypes = {
  cowCount: PropTypes.number.isRequired,
  cowType: PropTypes.string.isRequired,
  sort: PropTypes.string.isRequired,
  setSort: PropTypes.func.isRequired,
  showSidebar: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchHeader);
